var nr = 0;
$(function(){
    requestOffer.init();
});

var requestOffer = {

    // select product dropdown change
    selectProduct: function(productId, container, nr){
        $.fancybox.showLoading();
        $.ajax({
            type: 'post',
            data: {'do': 'showComponent', 'args[naam]' : 'OfferteAanvragenInner', 'module' : 'producten', 'id' : productId, 'nr': nr},
            success: function(data){
                $(container).replaceWith(data);
                $.fancybox.hideLoading();
                requestOffer.init();
                requestOffer.checkFields(container);
                requestOffer.showHide();
            }
        });
        return false;
    },

    // check fields, add greencheck mark
    checkFields: function(){
        $('.check-step-default').each(function(){
            $(this).siblings('.form__label-check').hide();
            if ($(this).val().length > 0){
                $(this).siblings('.form__label-check').show();
            }
        });
        $('.check-step-radio').each(function(){
            $(this).parents('.form__label-right:first').find('.form__label-check').hide();
            var name = $(this).attr('name');
            var checked = $(':input[name="' + name + '"]:checked').length;
            console.log('checked:' + checked);
            if (checked > 0){
                $(this).parents('.form__label-right:first').find('.form__label-check').show();
            }
        });
        $('.check-step-dependent').each(function(){
            $(this).siblings('.form__label-check').show();
            $(':input[data-dependency="' + $(this).attr('data-dependency') + '"]').each(function(){
                if ($(this).val().length === 0){
                    $(this).siblings('.form__label-check').hide();
                }
            });
        });
        if ($(':input[name="levertijd"]:checked').length > 0){
            $('#check-step-levertijd').show();
        }
    },

    // upload after user chose file
    uploadFile: function(file, callback, extraData){
        callback = (!callback ? null : callback);
        extraData = (!extraData ? null : extraData);
        $.fancybox.showLoading();
        var formData = new FormData();
        if (file.files.length > 0) {
            $.fancybox('<h1>Een ogenblik geduld</h1><p>Een ogenblik geduld, uw bestand wordt verwerkt.</p>');
            formData.append('file', file.files[0]);
            $.ajax({
                url: 'webshop/upload-file/',
                data: formData,
                type: 'POST',
                dataType: 'json',
                contentType: false,
                processData: false,
                success: function (data) {
                    $.fancybox.close();
                    if (data.success){
                        if (callback && typeof(callback) === "function"){
                            callback(data, extraData);
                        } else {
                            var html = '';
                            html += '<li data-file="' + data.path + '">';
                            html += '<a href="' + data.path + '" target="_blank">' + data.file + '</a>';
                            html += '<a href="#" onclick="$(\'#uploadedFile\').remove(); $(this).closest(\'li\').remove(); $(\'#file\').show(); return false;"><i class="fa fa-trash" aria-hidden="true"></i></a>';
                            html += '</li>';
                            $('#offer-files').append(html);
                            $('#file').hide();
                            $('#offer-form').append('<input type="hidden" id="uploadedFile" name="uploadFile" value="' + data.path + '" />');
                        }
                    } else {
                        $.fancybox(data);
                    }
                    $.fancybox.hideLoading();
                },
                error: function (data) {
                    $.fancybox.close();
                    alert('Er is een fout opgetreden bij het uploaden, controleer het bestand en probeer het opnieuw');
                    $.fancybox.hideLoading();
                }
            })
        }
    },

    // submit the form
    submit: function(form){
        var requiredFields1 = ['voornaam', 'achternaam', 'email'];
        var requiredFields2 = ['productId', '[formaat][0]', '[formaat][1]', '[formaat][2]', 'materiaal', 'bedrukking', 'belijming', 'afwerking'];
        var errors = 0;
        var field;

        $('.offer-inner-wrapper-rp').each(function(){
            for (var i=0; i<requiredFields1.length; i++){
                field = form.find($(':input[name*="' + requiredFields1[i] + '"]'));
                field.css('border-color', '#ebebec');
                if (field.val().length === 0){
                    field.css('border-color', 'red');
                    errors++;
                }
            }
            for (var i=0; i<requiredFields2.length; i++){
                field = $(this).find($(':input[name*="' + requiredFields2[i] + '"]'));
                field.css('border-color', '#ebebec');
                if (field.val().length === 0){
                    field.css('border-color', 'red');
                    errors++;
                }
            }
        });
        if (errors > 0){
            alert('Niet alle velden zijn (juist) ingevuld, controleer de velden en probeer het opnieuw');
        } else {
            form.append('<input type="hidden" name="action" value="submitForm" />');
            $.fancybox.showLoading();
            $.ajax({
                type: 'post',
                data: form.serialize(),
                dataType: 'json',
                success: function(data){
                    $.fancybox.hideLoading();
                    if (data.success){
                        window.location.href = data.url;
                    } else {
                        alert('Er is een onbekende fout opgetreden, probeer het opnieuw of raadpleeg de klantenservice.')
                    }
                }
            })
        }
        return false;
    },
    addProduct: function(){
        nr++;
        $.fancybox.showLoading();
        $.ajax({
            type: 'post',
            data: {'nr': nr, 'do' : 'showComponent', 'module': 'producten', 'args[naam]' : 'OfferteAanvragenInner'},
            success: function(data){
                $('.offerte-form-left-inner').append(data);
                $.fancybox.hideLoading();
                requestOffer.init();
                requestOffer.showHide();
            }
        })
    },
    deleteProduct: function(wrapper){
        wrapper.remove();
        requestOffer.showHide();
    },
    showHide: function(){
        $('.offerte-form-extra-product').closest('.form-group').show();
        if ($('.offerte-form-extra-product').length > 1){
            $('.offerte-form-extra-product:not(:last)').closest('.form-group').hide();
            $('.form-group-levertijd:last').hide();
        }
        $('.delete-product').show();
        $('.delete-product:first').hide();
    },

    init: function(){
        $('#offer-form .offer-select-product').change(function(){
            requestOffer.selectProduct($(this).val(), $(this).closest('.offer-inner-wrapper-rp'), $(this).closest('.offer-inner-wrapper-rp').attr('data-nr'));
        });
        requestOffer.checkFields();
        $('#offer-form :input').on('change keyup keydown', function(){
            setTimeout(function(){
                requestOffer.checkFields();
            }, 500)
        });
        $('#offer-form #file').off('change').on('change', function(){
            if ($(this).val().length > 0){
                requestOffer.uploadFile($('.offerte-form #file')[0]);
            }
        });
        $('#offer-form').off('submit').on('submit', function(){
            requestOffer.submit($(this));
            return false;
        });
        $('#offer-form .offerte-form-extra-product').off('click').on('click', function(){
            requestOffer.addProduct();
            return false;
        });
        $('#offer-form .delete-product').off('click').on('click', function(){
            requestOffer.deleteProduct($(this).closest('.offer-inner-wrapper-rp'));
            return false;
        });
        $( ".tooltip" ).tooltip({
            position: {
                my: "center bottom",
                at: "center top",
            }
        });
    }
};